import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';
import './Sidebar.css';

const Sidebar = ({ isMobileMenuOpen, setIsMobileMenuOpen }) => {
    const [collapsed, setCollapsed] = useState(false);
    const { t, i18n } = useTranslation();
    const { user, logout, isAdmin, isTeacher } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const adminLinks = [
        { path: '/admin', icon: 'dashboard', label: t('common.dashboard'), end: true },
        { path: '/admin/teachers', icon: 'people', label: t('common.teachers') },
        { path: '/admin/courses', icon: 'menu_book', label: t('common.courses') },
        { path: '/admin/department-reports', icon: 'analytics', label: t('common.departmentReports') },
        { path: '/admin/profile', icon: 'person', label: t('profile.title') }
    ];

    const teacherLinks = [
        { path: '/teacher', icon: 'dashboard', label: t('common.dashboard'), end: true },
        { path: '/teacher/courses', icon: 'menu_book', label: t('common.courses') },
        { path: '/teacher/profile', icon: 'person', label: t('profile.title') }
    ];

    const links = isAdmin ? adminLinks : teacherLinks;

    return (
        <aside className={`sidebar ${collapsed ? 'collapsed' : ''} ${isMobileMenuOpen ? 'open-mobile' : ''}`}>
            <div className="sidebar-header">
                {!collapsed && (
                    <div className="sidebar-brand">
                        <img src="/assets/img/logo.png" alt="Logo" className="sidebar-logo-img" />
                    </div>
                )}
                <button
                    className="sidebar-collapse-btn"
                    onClick={() => setCollapsed(!collapsed)}
                >
                    {collapsed ? '▶' : '◀'}
                </button>
            </div>

            <nav className="sidebar-nav">
                {links.map((link) => (
                    <NavLink
                        key={link.path}
                        to={link.path}
                        end={link.end}
                        className={({ isActive }) =>
                            `sidebar-link ${isActive ? 'active' : ''}`
                        }
                    >
                        <span className="material-icons">{link.icon}</span>
                        {!collapsed && <span className="link-label">{link.label}</span>}
                    </NavLink>
                ))}
            </nav>

            <div className="sidebar-footer">
                <button className="logout-button" onClick={handleLogout}>
                    <span className="material-icons">logout</span>
                    {!collapsed && <span>{t('common.logout')}</span>}
                </button>
            </div>
        </aside>
    );
};

export default Sidebar;

